export default function Show() {
  return <div className="h-full flex items-center justify-center">This is show page</div>;
}
